import { fetchClient } from '@/util/fetchClient';

export async function submitAuthenticatedQuestion(body: { message: string }) {
  const { data, error } = await fetchClient.POST('/v2/inquiries/new-question', {
    body,
  });

  if (error) {
    throw new Error('Failed to submit question');
  }

  return data;
}
